// extracted by mini-css-extract-plugin
export var errorIcon = "_l3-1";
export var nameLogo = "_l3-0";